import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
// Components
import OrderDetailsCard from 'components/prodJobDetails/OrderDetailsCard';
import CartDetailsCard from 'components/prodJobDetails/CartDetailsCard';
import { default as OrderDetails } from 'components/prodJobDetails/noDeviationComponents/OrderDetailsCard';
import LoadingOverlay from 'components/common/LoadingOverlay';
// Actions
import { setOrderDetailsAllData } from 'store/productionJob/ProductionJobActions';
// Selectors
import { getOrderDetails } from 'store/productionJob/ProductionJobSelectors';
import {getIsLoaderOpen } from 'store/app/AppSelectors';

const ProdJobDetailsPage = () => {
  const [hasSubmittedBefore, setHasSubmittedBefore] = useState([]),
    [hasDeviation, setHasDeviation] = useState([]),
    orderDetails = useSelector((state) => getOrderDetails({ state })),
    isLoaderOpen = useSelector((state) => getIsLoaderOpen({ state })),
    deviationEnabled = true,
    params = useParams(),
    dispatch = useDispatch();

  const fetchOrderDetails = (orderId) => {
    dispatch(setOrderDetailsAllData(orderId));
  };

  useEffect(() => {
    if (Object.keys(orderDetails).length > 0) {
      let deviationArr = [];
      let submittedArr = [];
      deviationArr.push({
        productId: orderDetails?.productId,
        hasDeviation: false,
        hasEditDeviation: false,
        productionId: orderDetails?.id,
      });
      submittedArr.push({
        productId: orderDetails?.productId,
        hasSubmittedBefore: false,
        productionId: orderDetails?.id,
      });
      setHasDeviation(deviationArr);
      setHasSubmittedBefore(submittedArr);
    }
  }, [orderDetails]);

  useEffect(() => {
    fetchOrderDetails(params.orderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoaderOpen && <LoadingOverlay />}
      {!isLoaderOpen && (
        <>
          {deviationEnabled ? (
            <OrderDetailsCard
              orderDetails={orderDetails}
              hasSubmittedBefore={hasSubmittedBefore}
              hasDeviation={hasDeviation}
            />
          ) : (
            <OrderDetails orderDetails={orderDetails} />
          )}
          <div className={`orderDetails-cart-wrapper ${deviationEnabled ? '' : 'no-deviation'}`}>
            <CartDetailsCard
              key={`item-key-${orderDetails?.productId}`}
              cartItem={orderDetails}
              orderMapId={orderDetails?.orderMapId}
              preparationStatus={orderDetails?.status}
              hasSubmittedBefore={hasSubmittedBefore}
              hasDeviation={hasDeviation}
              setHasSubmittedBefore={setHasSubmittedBefore}
              setHasDeviation={setHasDeviation}
              orderId={orderDetails?.id}
              floristMapId={orderDetails?.floristMapId}
              productId={orderDetails?.productId}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ProdJobDetailsPage;
